import axios from 'axios';

export const isDev = import.meta.env.MODE === 'development';

export const API_URL = isDev ? '' : window.origin;
export const CONTENT_URL = '';
export const STORAGE_URL = 'https://95160e01.gcdn.easyrocket.net';

export const apiProvider = axios.create({ baseURL: API_URL });

/** ( !devDomain && !localhostDomain ) || prodEnv */
export const isProductionEnv =
  (!window.origin.includes('macmillan') && !window.origin.includes('localhost')) ||
  import.meta.env.VITE_DOMAIN?.includes('fgfox');
